// test1742
(1742 && 0);
